import { render } from "./property-details.vue?vue&type=template&id=a24f71da&scoped=true&lang=pug"
import script from "./property-details.vue?vue&type=script&lang=js"
export * from "./property-details.vue?vue&type=script&lang=js"

import "./property-details.vue?vue&type=style&index=0&id=a24f71da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24f71da"]])

export default __exports__